import { ApiResourceBaseClass as a } from "./baseApiCalls.js";
const e = "product_upsale";
class r extends a {
  /**
   * Initiates an upsale action for a product.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/product_upsale/{product}`
   *
   * @param {ProductForUpsale} product - The product object to be upsold, containing the necessary details for the upsale.
   * @returns {Promise<SuccessResponse>} A promise that resolves to the success response containing the outcome of the upsale action.
   */
  upsale = async (s) => {
    const { data: t } = await this.post(`${e}/${s}`);
    return t;
  };
}
export {
  r as ProductUpsale
};
